// eslint-disable-next-line import/prefer-default-export
export enum OrgProfileContext {
  CREATE_ORG = 'create-org',
  CREATE_ACCOUNT = 'create-account',
  UPGRADE_TO_ORG = 'upgrade-to-org'
  // SWITCH_ACCOUNT = 'switch-account'
}
